import { render, staticRenderFns } from "./singleProductItem.vue?vue&type=template&id=0db3562a"
import script from "./singleProductItem.vue?vue&type=script&lang=js"
export * from "./singleProductItem.vue?vue&type=script&lang=js"
import style0 from "./singleProductItem.vue?vue&type=style&index=0&id=0db3562a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports